import { zRequiredDate, zRequiredString, zString } from '@/form/zod.utils';
import z from 'zod';

export const bucketPathPattern = /[\w@:+.-]+(\/[\w@:+.-]+)?/;
export const bucketPathRules =
  'Must be prefix, allow the basic Latin alphabet, the underscore (_), the symbol (@), the colon (:), the plus sign (+), the periods (.) and hyphen (-).';

const analysisSchema = z.object({
  dateOfCreation: zRequiredDate,
  projectId: zRequiredString,
  sequencingTypeId: zString,
  allowPartialRun: z.boolean().optional(),
  forceRun: z.boolean().optional(),
  analysisBatchSyncBucket: zString.optional(),
  analysisBucketPath: z.preprocess(
    v => (v === '' ? undefined : v),
    z
      .string()
      .regex(bucketPathPattern, { message: bucketPathRules })
      .nullable()
      .optional(),
  ),
});
const validateBucketPath = (data: {
  analysisBatchSyncBucket?: string | null;
  analysisBucketPath?: string | null;
}) =>
  !data.analysisBatchSyncBucket ||
  data.analysisBatchSyncBucket.trim() === '' ||
  !!(
    data.analysisBucketPath && String(data.analysisBucketPath).trim().length > 0
  );

export const createAnalysisSchema = analysisSchema.refine(validateBucketPath, {
  path: ['analysisBucketPath'],
  message: 'Required',
});

export const updateAnalysisSchema = analysisSchema
  .partial()
  .refine(validateBucketPath, {
    path: ['analysisBucketPath'],
    message: 'Required',
  });
